import { render, staticRenderFns } from "./MasterCategory.vue?vue&type=template&id=56e64c88&scoped=true&"
import script from "./MasterCategory.vue?vue&type=script&lang=js&"
export * from "./MasterCategory.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=56e64c88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e64c88",
  null
  
)

export default component.exports